<template>
  <div  :style="pureBaseStyle" @click="handleClickEvent()">
    <p
      :class="getCss('bind-btn-text')"
      :style="wrapStyle"
      @click="checkJoinClub()"
    >
      {{ btnText }}
    </p>
    <!-- 绑定俱乐部弹窗start -->
    <div :class="getCss('tc')" v-show="isShow">
      <div :class="getCss('tc-zz')"></div>

      <div :class="getCss('tc-div')">
        <div :class="getCss('tc-text-body')">
          <p :class="getCss('tc-title')">绑定俱乐部</p>
          <div
            :class="getCss('tc-body')"
            v-show="bindClubStatus === 1 && !loading"
          >
            <div :class="getCss('tc-select-div')">
              <p :class="getCss('tc-not-join-msg')">
                已绑定：{{ selectClubName }}
              </p>
            </div>

            <div :class="getCss('tc-foot-btn')">
              <span :class="getCss('tc-foot-center-btn')" @click="closeDialog()"
                >好的</span
              >
            </div>
          </div>
          <div
            :class="getCss('tc-body')"
            v-show="bindClubStatus === 2 && !loading"
          >
            <div :class="getCss('tc-select-div')">
              <p :class="getCss('tc-not-join-msg')">
                已绑定：{{ selectClubName }}，你已经不在该俱乐部中
              </p>
            </div>

            <div :class="getCss('tc-foot-btn')">
              <span :class="getCss('tc-foot-center-btn')" @click="closeDialog()"
                >好的</span
              >
            </div>
          </div>
          <div
            :class="getCss('tc-body')"
            v-show="bindClubStatus === 3 && !loading"
          >
            <div :class="getCss('tc-select-div')">
              <p :class="getCss('tc-not-join-msg')">{{ noJoinTips }}</p>
            </div>

            <div :class="getCss('tc-foot-btn')">
              <span :class="getCss('tc-foot-center-btn')" @click="closeDialog()"
                >好的</span
              >
            </div>
          </div>
          <div
            :class="getCss('tc-body')"
            v-show="bindClubStatus === 4 && !loading"
          >
            <div :class="getCss('tc-select-div')">
              <select
                :class="getCss('tc-select')"
                name="selectClub"
                v-model="selectClubId"
                @change="changeClub($event)"
              >
                <option value="0">请选择俱乐部</option>
                <option
                  v-for="(options, id) in selectClubData"
                  :key="id"
                  :value="options.club_id"
                >
                  {{ options.club_name }}
                </option>
              </select>
            </div>

            <div :class="getCss('tc-foot-btn')">
              <span :class="getCss('tc-foot-center-btn')" @click="bindClubClick"
                >确认绑定</span
              >
            </div>
          </div>
          <div :class="getCss('tc-body')" v-show="loading">
            <div :class="getCss(['tc-select-div', 'loading'])">
              <div :class="getCss('load8')">
                <div :class="getCss(['load8-container', 'container1'])">
                  <div :class="getCss('circle1')"></div>
                  <div :class="getCss('circle2')"></div>
                  <div :class="getCss('circle3')"></div>
                  <div :class="getCss('circle4')"></div>
                </div>
                <div :class="getCss(['load8-container', 'container2'])">
                  <div :class="getCss('circle1')"></div>
                  <div :class="getCss('circle2')"></div>
                  <div :class="getCss('circle3')"></div>
                  <div :class="getCss('circle4')"></div>
                </div>
                <div :class="getCss(['load8-container', 'container3'])">
                  <div :class="getCss('circle1')"></div>
                  <div :class="getCss('circle2')"></div>
                  <div :class="getCss('circle3')"></div>
                  <div :class="getCss('circle4')"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="getCss('tc-close-div')">
          <span :class="getCss('tc-close')" @click="closeDialog()">
            <img
              src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/close.png"
              alt=""
            />
          </span>
        </div>
      </div>
    </div>
    <!-- 绑定俱乐部弹窗end -->
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { baseComponents, componentBaseMixin } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CPopupBindClub',
  components: {
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'popup-bind-club-',
      isShow: false,
      bindClubStatus: 0, // 0-未绑定；1-已绑定，未退出；2-已绑定，已退出；3-未加入俱乐部；4-加入俱乐部，未绑定
      selectClubEnd: 0,
      selectClubData: [],
      selectClubId: 0,
      bindClubId: 0,
      selectClubName: '',
      isInClub: 0,
      loading: true,
    };
  },
  computed: {
    pureBaseStyle() {
      return {
        left: this.styles.base.left,
        top: this.styles.base.top,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    wrapStyle() {
      const { bgImage } = this.configurationData;
      const fontStyle = this?.styles?.fontStyle || {};
      return {
        ...this.styles.base,
        ...fontStyle,
        backgroundImage: `url(${bgImage})`,
        backgroundSize: '100% 100%',
      };
    },
    btnTextStyle() {
      const fontStyle = this?.styles?.fontStyle || {};
      const show = this?.styles?.base?.display || 'block';
      return {
        ...fontStyle,
        top: this.styles.base?.top,
        left: this.styles.base?.left,
        width: this.styles.base?.width || '2rem',
        height: this.styles.base?.height || '0.5rem',
        display: `${show}`,
      };
    },
    btnText() {
      // 文字内容
      return this.configurationData.btnText || '';
    },
    noJoinTips() {
      // 未加入俱乐部提示文字内容
      return this.configurationData.noJoinTips || '请先加入俱乐部后参与活动';
    },
    allowChangeBind() {
      return this.configurationData.allowChangeBind || false;
    },
  },
  mounted() {
    console.log('【popup-bind-club】configurationData', this.configurationData);
    this.initialize();
    const select1 = document.getElementsByClassName('csu-popup-bind-club-tc-select')[0];
    let scrollHeight1 = 0;
    select1.onfocus = function () {
      scrollHeight1 = window.scrollY;
    };

    select1.onblur = function () {
      window.scrollTo(0, scrollHeight1);
    };
  },
  methods: {
    async initialize() {
      if (this.$isInEditor && !this.isInPreview) return;
      const self = this;
      // 监听user.ready
      this.$onLogined(async () => {
        await this.checkBindFlowID();
      });
      // this.checkBindFlowID();
      // 监听package.club.fill
      this.$eventBus.$on('ceiba:common:events:club-fill', () => {
        self.checkJoinClub();
      });
      // 监听其他场景，比如切换游戏
      this.$eventBus.$on('ceiba:common:events:club-refresh', () => {
        self.checkBindFlowID();
      });
    },
    async checkBindFlowID() {
      const { checkBindFlowID } = this.configurationData;
      if (!checkBindFlowID) return;
      const response = await this.flowRequest({ flowId: checkBindFlowID });
      console.log('【popup-bind-club】查询绑定的俱乐部', response);
      if (response.data.ret === 0) {
        this.isInClub = response.data.isInClub;
        if (response.data.match === 1 && this.isInClub === 1) {
          // 已绑定
          const clubInfo = response.data.bindInfo;
          this.bindClubId = clubInfo.club_id;
          this.selectClubName = clubInfo.club_name;
          await this.UPDATE_BIND_CLUB(this.bindClubId);
          await this.UPDATE_SHIPPING_CODE(clubInfo.code);
          console.log(this.bindClub, 'bindClub');
          console.log(this.shipping_code, 'shipping_code');
          console.log('【popup-bind-club】bindClubId==', this.bindClubId);
        } else {
          // 未绑定
          this.bindClubId = 0;
        }
      } else {
        this.alert(response.msg);
      }
    },
    async checkJoinClub() {
      if (this.$isInEditor) return;
      // 强制登陆
      if (!this.isLogin) {
        baseComponents.userLoginComponent.login();
        return;
      }
      if (this.configurationData.isNeedInApp && !this.$ast.isAPP()) {
        this.$ast.gotoAPP();
        return false;
      }
      this.showDialog();
      this.loading = true;
      const response = await this.flowRequest({
        flowId: this.configurationData.queryJoinFlowID,
      });
      console.log('【popup-bind-club】查询是否加入俱乐部', response);
      if (response.data.ret === 0) {
        this.loading = false;
        if (response.data.joined === 1) {
          // 已加入
          const list = JSON.parse(response.data.list);
          console.log('【popup-bind-club】selectClubData====', list);
          this.selectClubData = list;
          if (this.allowChangeBind || this.bindClubId === 0) {
            this.bindClubStatus = 4;
            if (this.bindClubId !== 0 && this.isInClub === 1) {
              this.selectClubId = this.bindClubId;
            }
            console.log('【popup-bind-club】bindClubId === ', this.bindClubId);
          } else {
            if (this.bindClubId !== 0 && this.isInClub === 1) {
              this.bindClubStatus = 1;
              await this.UPDATE_BIND_CLUB(this.bindClubId);
            } else {
              this.bindClubStatus = 2;
              this.UPDATE_BIND_CLUB('');
            }
          }
        } else {
          // 未加入
          this.bindClubStatus = 3;
        }
      } else {
        this.alert(response.msg);
      }
    },
    changeClub(event) {
      console.log('【popup-bind-club】changeclub==', event.target.value);
      this.selectClubId = event.target.value;
    },
    async bindClubClick() {
      if (!this.configurationData.bindClubFlowID) {
        this.alert('绑定流程id未配置');
        return;
      }
      if (this.selectClubId === 0 || this.selectClubId === '0') {
        this.$toast('请选择俱乐部');
        return;
      }
      const selectInfo = this.selectClubData.find(club => club.club_id === Number(this.selectClubId));
      console.log('【popup-bind-club】selectInfo==', selectInfo);
      const postData = {
        club_id: selectInfo.club_id,
        club_name: selectInfo.club_name.trim(),
        avatar_info: selectInfo.avatar_info,
      };
      const response = await this.flowRequest({
        flowId: this.configurationData.bindClubFlowID,
        params: {
          data: JSON.stringify(postData),
          role: this.roleInfo,
        },
      });
      if (response.data.ret === 0) {
        this.alert('绑定成功');
        this.refreshQua(); // 绑定成功触发刷新
        this.bindClubStatus = 1;
        this.bindClubId = this.selectClubId;
        this.UPDATE_BIND_CLUB(Number(this.selectClubId));
        this.closeDialog();
        await this.checkBindFlowID();
        /* this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_qq',
          eventData: {
            status: '1',
          },
        });*/
      } else {
        this.alert(response.msg);
        this.selectClubId = 0;
        this.closeDialog();
        /* this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_qq',
          eventData: {
            status: '0',
          },
        });*/
      }
    },
    showDialog() {
      this.isShow = true;
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
    },
    closeDialog() {
      this.isShow = false;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
